import React, { useState } from 'react'
import styled from 'styled-components'
import Ecosystem from '../Ecosystem'
import { ButtonPrimary, ButtonSecondary } from 'components/Button'
import { REFERRAL_FOR_USERS_PARAMS } from 'pages/utils/ReferralHandler'
import { Text } from 'rebass'
import { useActiveWeb3React } from 'hooks'
import { usePrivy } from '@privy-io/react-auth'

const SidebarContainer = styled.div`
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background: ${({ theme }) => theme.bg0};
  padding: 32px 24px;

  p {
    font-size: 16px;
    font-weight: 400;
    color: ${({ theme }) => theme.text2};
    margin: 0;
  }

  @media (max-width: 768px) {
    display: none;
  }
`

const Sidebar: React.FC<{ username: null | string; openModal: () => void }> = ({ username, openModal }) => {
  const { account } = useActiveWeb3React()
  const { login } = usePrivy()

  const [copyStatus, setCopyStatus] = useState<string | null>(null) // State to manage copy status
  const saveLink = () => {
    if (username) {
      const referralLink = `${window.location.origin}/#/swap?${REFERRAL_FOR_USERS_PARAMS}=${username}`
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(referralLink)
          .then(() => {
            setCopyStatus('Copied!')
            setTimeout(() => setCopyStatus(null), 5000)
          })
          .catch(() => {
            // Fallback to manual copy if writeText fails
            fallbackCopyTextToClipboard(referralLink)
          })
      } else {
        // Fallback for older browsers
        fallbackCopyTextToClipboard(referralLink)
      }
    }
  }

  // Fallback function using document.execCommand('copy')
  const fallbackCopyTextToClipboard = (text: string) => {
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.style.position = 'fixed' // Prevent scrolling to bottom of page in Microsoft Edge.
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
      const successful = document.execCommand('copy')
      if (successful) {
        setCopyStatus('Copied!')
      } else {
        setCopyStatus('Copy failed')
      }
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err)
    }

    document.body.removeChild(textArea)
    setTimeout(() => setCopyStatus(null), 5000)
  }

  return (
    <div>
      <SidebarContainer>
        <Ecosystem styles={{ height: 'unset', background: 'unset', overflow: 'visible' }} small />
        <p>
          Claim your unique Username ID and start earning points as you navigate on HyperSwap and the HyperEVM
          ecosystem. <br /> <br /> Climb the leaderboard and earn points.
          <br /> <br />
          Join now!
        </p>
        {!account ? (
          <ButtonPrimary
            onClick={() =>
              login({
                loginMethods: ['wallet'],
                walletChainType: 'ethereum-only',
                disableSignup: false,
              })
            }
          >
            Connect Wallet
          </ButtonPrimary>
        ) : (
          <>
            {username ? (
              <ButtonSecondary id="copy" style={{ padding: 16 }} as={'button'} onClick={saveLink}>
                <Text fontWeight={400} fontSize={14} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  {copyStatus || 'Copy my referral link'}
                </Text>
              </ButtonSecondary>
            ) : (
              <ButtonSecondary onClick={() => openModal()}>Sign up</ButtonSecondary>
            )}
          </>
        )}
      </SidebarContainer>
    </div>
  )
}
export default Sidebar
